<template>
  <component :is="component"></component>
</template>

<script>
import ProsperDeal from "@/platforms/prosper/components/deals/deal-item.vue";
import GabonDeal from "@/platforms/gabon/components/deals/deal-item.vue";
import config from "@/config/platform.config";

export default {
  name: "custom-menu",
  components: {
    ProsperDeal,
    GabonDeal,
  },
  computed: {
    component() {
      const map = {
        crossboundary: ProsperDeal,
        gabon_invest: GabonDeal,
      };
      return map[config.platformId] || ProsperDeal;
    },
  },
};
</script>
